import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import { delayHttpRequest } from '../helpers/globalHelper'
import { Departments, clockstatus } from '../types/clockTypes'
import { clockService } from '../services/clockService'

type store = {
  departmentsData: Departments
  postData: any
  clockStatusData: clockstatus
  loading: boolean
  error: null
  attendancelogkey: number
  fetchdepartments: (id: number, storeId: number, userid: number) => void
  postclockin: (feed: any) => void
  updateclockin: (feed: any) => void
  fetchattendancelogkey: (
    obkey: number,
    shiftid: number,
    employeeid: number,
    userid: number
  ) => void
  fetchClockinStatus: (
    obkey: number,
    shiftid: number,
    employeeid: number,
    userid: number,
    date: string
  ) => void
}

const useclockstore = create(
  devtools<store>((set, get) => ({
    departmentsData: null,
    attendancelogkey: 0,
    postData: null,
    clockStatusData: null,
    loading: false,
    error: null,
    fetchdepartments: async (id, storeId, userid) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        const _departments = await clockService.fetchdepartments(
          id,
          storeId,
          userid
        )
        set((state) => ({ ...state, departmentsData: _departments }))
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postclockin: async (feed) => {
      set((state) => ({ ...state, loading: true }))
      try {
        const _Data = await clockService.postclockin(feed)
        set((state) => ({ ...state, postData: _Data }))
        // console.log(useclockstore.getState().postData)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    updateclockin: async (feed) => {
      set((state) => ({ ...state, loading: true }))
      try {
        const _Data = await clockService.updateclockin(feed)
        set((state) => ({ ...state, postData: _Data }))
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    fetchattendancelogkey: async (
      obkey: number,
      shiftid: number,
      employeeid: number,
      userid: number
    ) => {
      set((state) => ({ ...state, loading: true }))
      try {
        const _Data = await clockService.fetchattendancelogkey(
          obkey,
          shiftid,
          employeeid,
          userid
        )
        set((state) => ({ ...state, attendancelogkey: _Data }))
        //console.log(useclockstore.getState().attendancelogkey)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    fetchClockinStatus: async (
      obkey: number,
      shiftid: number,
      employeeid: number,
      userid: number,
      date: string
    ) => {
      set((state) => ({ ...state, loading: true }))
      try {
        const _Data = await clockService.fetchClockinStatus(
          obkey,
          shiftid,
          employeeid,
          userid,
          date
        )
        set((state) => ({ ...state, clockStatusData: _Data }))
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    }
  }))
)

export { useclockstore }
